import {Component} from '@angular/core'
import {RouterLink, RouterOutlet} from '@angular/router'
import {MatToolbar} from '@angular/material/toolbar'
import {MatIcon} from '@angular/material/icon'
import {MatButton, MatIconButton} from '@angular/material/button'
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from '@angular/material/sidenav'
import {MatCard, MatCardContent} from '@angular/material/card'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'

@Component({
  selector: 'ohl-root',
  imports: [RouterOutlet,
    MatToolbar,
    MatIcon,
    MatIconButton,
    MatDrawerContainer,
    MatDrawer,
    MatDrawerContent,
    MatCard,
    MatCardContent, MatButton, MatMenuTrigger, MatMenu, RouterLink, MatMenuItem
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
}
